var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13C17.1046 13 18 12.1046 18 11C18 9.89543 17.1046 9 16 9C14.8954 9 14 9.89543 14 11C14 12.1046 14.8954 13 16 13Z",
    stroke: "#0474F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21C17.1046 21 18 20.1046 18 19C18 17.8954 17.1046 17 16 17C14.8954 17 14 17.8954 14 19C14 20.1046 14.8954 21 16 21Z",
    stroke: "#0474F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7C6.10457 7 7 6.10457 7 5C7 3.89543 6.10457 3 5 3Z",
    stroke: "#0474F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8V15C5 16.886 5 17.828 5.586 18.414C6.172 19 7.114 19 9 19H14",
    stroke: "#0474F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7C5 8.886 5 9.828 5.586 10.414C6.172 11 7.114 11 9 11H14",
    stroke: "#0474F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.3cdeb553185e5c35d4a149629fdc4ee4.svg";
export { ForwardRef as ReactComponent };